module.exports = RedNaoFormBuilder.default('FormBuilder/Fields/Core/ConditionOptions');